import React from 'react'
import Card from '@softwaredev_cegeka/stix-core/dist/components/Card'
import Grid from '@softwaredev_cegeka/stix-core/dist/components/Grid'
import Icon from '@softwaredev_cegeka/stix-core/dist/components/Icon'
import './unauthorizedCard.scss'

class UnauthorizedCard extends React.Component {
    render() {
        return (
            <Grid.Row>
                <Grid.Col md={{ offset: 4, span: 4 }}>
                    <Card className={'unauthorized-card'}>
                        <Card.Body>
                            <Icon icon={'lock'} />
                            <div className={'unauthorized-content'}>
                                <Card.Title className={'unauthorized-title'}>
                                    Unauthorized
                                </Card.Title>
                                <p>
                                    You are not authorized to access this data.
                                </p>
                            </div>
                        </Card.Body>
                    </Card>
                </Grid.Col>
            </Grid.Row>
        )
    }
}

export default UnauthorizedCard
